module.exports = __webpack_public_path__ + "img/65.6e7bcdd5.png";